import {
  getActivePendingToolConfirmation,
  getActiveSessionToolConfirmation,
  getInputRequests,
} from '@github-ui/ahp-relay/ahp-session-selectors'
import {ahpInputRequestToPrompt} from '@github-ui/copilot-shared-ui/ahp/ahp-prompt-conversion'
import type {AhpSessionBundle} from './replay-ahp-events'

export function hasPendingAhpUserPrompt(bundle: AhpSessionBundle | undefined): boolean {
  if (!bundle) return false
  if (getActiveSessionToolConfirmation(bundle.sessionState)) return true
  const chat = bundle.defaultChatState
  return (
    !!chat &&
    (getInputRequests(chat).some(request => !!ahpInputRequestToPrompt(request)) ||
      !!getActivePendingToolConfirmation(chat))
  )
}
